import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { HOST_URL, reqOptions } from "../../assets/js/helpFunction";
import styled from "styled-components";
import WithAuth from "../../components/partials/withAuth";
import { SVGs } from "../../assets/svg/SVGs";
import { getEstateID, MssgContainer } from "../../components/partials/utils";
import { useCurrentLocation } from "../../utils/useLocation";
import PatrolAreaComp from "./PatroAreas";
import CheckpointsComp from "./Checkpoints";
import SchedulesComp from "./Schedules";

const Security = () => {
  const [openModal, setOpenModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const [patrolAreas, setPatrolAreas] = useState([]);
  const [data, setData] = useState({});
  const [editedPatrolArea, setEditedPatrolArea] = useState({});
  const [mssg, setMssg] = useState({ error: false, mssg: "" });
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const closeMssg = () => {
    setMssg({ error: false, mssg: "" });
  };

  const fetchPatrolAreas = () => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}patrols/manage/areas?estate_id=${getEstateID()}`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setPatrolAreas(data.results);
        setData(data);
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }));
  };

  useEffect(() => {
    fetchPatrolAreas();
  }, []);

  const editPatrolArea = (id) => {
    const item = patrolAreas.find((element) => element.id == id);
    setEditedPatrolArea(item);
    setEdit(true);
    setOpenModal(true);
  };

  const addUtility = (patrolArea) => {
    setLoading(true);
    if (edit) {
      const api = `${HOST_URL()}patrols/manage/areas/${editedPatrolArea?.id}/?estate_id=${getEstateID()}`;
      const requestOptions = reqOptions(
        "patch",
        JSON.stringify(patrolArea),
        true,
      );
      fetch(api, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          if (data.id) {
            setMssg({ ...mssg, mssg: "Patrol Area Updated successfully" });
            fetchPatrolAreas();
            // const edited_data = patrolAreas.map((item) => {
            //   if (item.id == editedPatrolArea.id) {
            //     return data;
            //   }
            //   return item;
            // });
            // setPatrolAreas(edited_data);
            setOpenModal(false);
          } else {
            setMssg({
              ...mssg,
              mssg: "Error Updating Patrol Area",
              error: true,
            });
          }
        })
        .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }))
        .finally(() => {
          setLoading(false);
        });
    } else {
      const api = `${HOST_URL()}patrols/manage/areas/?estate_id=${getEstateID()}`;
      const requestOptions = reqOptions(
        "post",
        JSON.stringify(patrolArea),
        true,
      );
      fetch(api, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          if (data.id) {
            setMssg({ ...mssg, mssg: "Patrol Area Created successfully" });
            // setPatrolAreas([...patrolAreas, data]);
            fetchPatrolAreas();
            setOpenModal(false);
          } else {
            setMssg({
              ...mssg,
              mssg: "Error Creating Patrol Area",
              error: true,
            });
          }
        })
        .catch((err) => {
          setMssg({ ...mssg, mssg: err.name, error: true });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const deletePatrolArea = (id) => {
    setDeleting(true);
    const api = `${HOST_URL()}patrols/manage/areas/${id}/?estate_id=${getEstateID()}`;
    const requestOptions = reqOptions("delete", null, true);
    fetch(api, requestOptions)
      .then((res) => {
        if (res?.ok) {
          fetchPatrolAreas();
          setMssg({
            ...mssg,
            mssg: "Patrol Area deleted successfully",
            error: true,
          });
        }
      })
      .catch((err) => {
        setMssg({ ...mssg, mssg: err.message, error: true });
      })
      .finally(() => setDeleting(false));
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditedPatrolArea({});
    setEdit(false);
  };

  return (
    <WithAuth>
      <PatrolAreaComp />
      <div style={{ marginTop: "50px" }}>
        <CheckpointsComp />
      </div>
      <div style={{ marginTop: "50px" }}>
        <SchedulesComp />
      </div>
    </WithAuth>
  );
};

export default Security;

const PatrolArea = ({
  patrolAreas,
  patrolArea,
  editPatrolArea,
  fetchPatrolAreas,
  deletePatrolArea,
  deleting,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [report, setReports] = useState([]);
  const [data, setData] = useState({});

  const addReport = (report) => {
    setReports((prev) => [...prev, report]);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="utils">
        <div className="util-payment">
          <div className="name_tag">
            <h4>{patrolArea.name}</h4>
            {/* <button>{patrolArea.name}</button> */}
          </div>

          <div className="util-acct">
            <p>
              Description: <b>{patrolArea.description || "-"}</b>
            </p>
            <div className="price">
              <p>{new Date(patrolArea.timestamp).toLocaleString()}</p>
            </div>
          </div>
          <div style={{ marginTop: "15px" }}>
            <span
              className="edit-btn util-btn"
              onClick={() => editPatrolArea(patrolArea.id)}
            >
              Edit
            </span>
            <span
              aria-disabled={deleting}
              className="del-btn util-btn"
              onClick={() => deletePatrolArea(patrolArea.id)}
            >
              {/* {deleting ? "Deleting..." : "Delete"} */}
              Delete
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

const Modal = ({
  mssg,
  loading,
  open,
  onClose: passedClose,
  addUtility,
  edit_data,
  edit,
  patrolAreas,
}) => {
  const default_patrolarea = {
    name: edit_data?.name || "",
    description: edit_data?.description || "",
  };
  const [patrolArea, setPatrolArea] = useState(default_patrolarea);
  // const { loading: locationLoading, getLocation } = useCurrentLocation();

  useEffect(() => {
    if (edit_data) {
      setPatrolArea({
        name: edit_data?.name,
        description: edit_data?.description,
      });
    }
  }, [edit_data]);

  if (!open) return null;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPatrolArea({ ...patrolArea, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addUtility(patrolArea);
    setPatrolArea(default_patrolarea);
    onClose(false);
  };
  const isValid = patrolArea.name && patrolArea.description;

  const onClose = () => {
    passedClose();
    setPatrolArea(default_patrolarea);
  };

  return (
    <div onClick={onClose} className="bills_on_me">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
      >
        <div className="new_estates_form fade-in-bck">
          <div className="form-group">
            <div className="create_est ">
              <div className="form_txt">
                <h3>{edit ? "Edit" : "Add a"} patrol area</h3>
              </div>
              <input
                type="text"
                value={patrolArea.name}
                name="name"
                placeholder="Name"
                onChange={handleChange}
              />
              <input
                type="text"
                placeholder="Description"
                value={patrolArea.description}
                name="description"
                onChange={handleChange}
              />
            </div>
          </div>
          {mssg?.mssg && (
            <p style={{ color: "red", fontSize: "12px", textAlign: "center" }}>
              {mssg?.mssg}
            </p>
          )}
          <button
            style={{ marginTop: 40 }}
            disabled={!isValid || loading}
            className="btn btn-success btn-block"
            onClick={handleSubmit}
          >
            {loading ? "Loading..." : `${edit ? "Edit" : "Add"} patrol area`}
          </button>
        </div>
        <img src={SVGs.close} alt="" onClick={onClose} />
      </div>
    </div>
  );
};

const HandleSearchAndTab = styled.section`
  .container {
    margin-bottom: 20px;
  }
  .normal_tab {
    background: transparent;
  }
  .event-input {
    max-width: 675px;
  }
  @media (max-width: 420px) {
    .search_set,
    button {
      width: 100%;
      margin-bottom: 20px;
    }
  }
  @media (min-width: 760px) {
    display: flex;
    justify-content: space-between;
    .search_set {
      width: 220px;
    }
    .outlined {
      width: 180px !important;
    }
    .event-input {
      display: flex;
      justify-content: space-between;
      //   width: 57%;
      .select_me {
        margin: 0 10px;
        width: 135px;
      }
      button {
        margin-top: 0;
        height: 45px;
        margin-left: 10px;
      }
      .event-select {
        width: 20%;
      }
    }
  }
  @media (max-width: 540px) {
    .event-input {
      .event-select {
        display: none;
      }
    }
  }
  .tabs {
    margin: 0;
    margin-bottom: 30px;
    .tab {
      margin: 0;
      height: 45px;
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 0;
      min-width: 100px;
      padding: 5px 20px;
      text-align: center;
      margin-right: 15px;
      border-bottom: 3px solid #c0c0c0;
      button {
        margin: 0;
        padding: 0 !important;
        padding: 10px;
        //styleName: Web/Small Copy;

        font-size: 16px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .active {
      background: transparent;
      border-bottom: 3px solid #2d4bf3;
      button {
        color: #2d4bf3;
      }
    }
  }
  .normal_tab.add_tape {
    border-bottom: 2px solid yellow;
  }
`;
const PatrolGrid = styled.div`
  .team-members {
    margin-top: 40px;
  }

  .Utility_table {
    display: flex;
    flex-wrap: wrap;
  }
  .btn {
    display: flex;
  }
  .utils {
    margin-bottom: 10px;
    margin: 10px;
    padding: 16px;
    width: 100%;
    border: 1px solid #2d4bf3;
    border-radius: 5px;
    .name_tag {
      h4 {
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
      }
      button {
        margin: 0;
        font-weight: 400;
        padding: 2px 8px;

        font-size: 14px;
        margin-top: 10px;
        background: #f2f6ff;
        border: 1px solid #2d4bf3;
        border-radius: 5px;
      }
    }
  }

  .reason {
    width: 128px;
    height: 24px;
    background: #f2f6ff;
    border: 1px solid #2d4bf3;
    border-radius: 5px;
    padding: 4px 8px;
  }
  .price {
    margin-top: 10px;
  }
  .util-acct {
    margin-top: 10px;
  }

  .util-btn {
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .del-btn {
    color: #ff6969;
  }
  .edit-btn {
    color: #2d4bf3;
  }
  @media (min-width: 540px) {
    .utils {
      width: 48%;
    }
  }
  @media (min-width: 1024px) {
    .utils {
      width: 33%;
    }
  }
  @media (min-width: 1200px) {
    .utils {
      width: 24%;
    }
  }
`;
